import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook--sprite",
  "use": "facebook--sprite-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"facebook--sprite\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <circle cx=\"8\" cy=\"8\" r=\"8\" fill=\"#565D60\" />\n        <path fill=\"#FFF\" d=\"M6.702 12h1.405V8.002H9.16l.208-1.25H8.107v-.905c0-.291.182-.598.442-.598h.717V4h-.879v.006c-1.375.051-1.657.877-1.682 1.744h-.003v1.003H6v1.249h.702V12z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol